/**
 * Het token van een uitnodigingslink — ADR-0036, besluit 3.
 *
 * De link uit de mail is `…/questionnaires/invite#t=<token>`. Het token staat in het
 * **fragment**, en dat is de hele bescherming: een fragment stuurt de browser nooit mee
 * naar de server, dus het komt niet in een toegangslog en niet in een `Referer`. Het
 * scherm leest het hier en stuurt het in de **body** van een POST, nooit in een URL.
 *
 * ⚠️ DAAROM LEEST DEZE FUNCTIE ALLEEN HET FRAGMENT, en bewust niet de query. Een link met
 * `?t=` is een link die al in een log staat; die hoort niet te werken, anders gaat iemand
 * hem zo maken.
 *
 * Wat de browser wél lokaal bewaart (de adresbalk, de geschiedenis) laten we staan: dan
 * werkt herladen halverwege het invullen nog. Wat er naar buiten gaat, zoals een
 * foutmelding naar de foutregistratie, gaat eerst door {@link redactInviteTokens}.
 */

/** De naam van de parameter in het fragment: `#t=<token>`. */
const PARAM = 't';

/**
 * Het token uit een fragment (`location.hash`, dus mét `#`), of `null` als er geen bruikbaar
 * token is. Alles wat niet met `#` begint, is geen fragment — ook een `?t=…`, dat
 * `URLSearchParams` anders zonder morren zou lezen.
 */
export function readInviteToken(hash: string): string | null {
  if (!hash.startsWith('#')) {
    return null;
  }

  const token = new URLSearchParams(hash.slice(1)).get(PARAM)?.trim() ?? '';

  return token === '' ? null : token;
}

/**
 * Elk token in een tekst vervangen door een markering. Voor alles wat de browser verlaat
 * zonder dat wij het verzoek zelf bouwen: de foutregistratie neemt de URL van de pagina
 * mee (met fragment) en bewaart elke navigatie als kruimel.
 *
 * Ook `?t=` en `&t=`: die horen er nooit te staan, en juist dán moet hij niet weglekken.
 */
export function redactInviteTokens<T extends string | undefined>(text: T): T {
  if (!text) {
    return text;
  }

  return text.replace(/([#?&]t=)[^&#\s"'<>]+/g, '$1[token geredigeerd]') as T;
}
